import PropTypes from 'prop-types'
import React from 'react'

import COLORS from '@components/branding/colors'

import Box from './box'
import Divider from './divider'
import Stack from './stack'
import Text from './text'

const NumberLabel = ({ children }) => (
  <Box
    sx={{
      typography: 'avenir16Bold',
      color: COLORS.brand.color,
      background: '#fff',
      minWidth: '2em',
      height: '2em',
      lineHeight: '2em',
      textAlign: 'center',
      borderRadius: '100%',
    }}
  >
    {children}
  </Box>
)

NumberLabel.propTypes = {
  children: PropTypes.node.isRequired,
}

const NumberedStep = ({ number, children }) => (
  <Stack direction="row" spacing={3}>
    <NumberLabel>{number}</NumberLabel>
    <Text variant="avenir14">{children}</Text>
  </Stack>
)

NumberedStep.propTypes = {
  number: PropTypes.number,
  children: PropTypes.node.isRequired,
}

NumberedStep.defaultProps = {
  number: 1,
}

NumberedStep.Title = ({ children }) => (
  <Box marginBottom={1}>
    <Text variant="avenir20Bold">{children}</Text>
  </Box>
)

NumberedStep.Title.propTypes = {
  children: PropTypes.node.isRequired,
}

NumberedStep.Container = ({ children }) => (
  <Box>
    <Stack direction="column" spacing={3} divider={<Divider />}>
      {children}
    </Stack>
    <Box marginTop={3}>
      <Divider />
    </Box>
  </Box>
)

NumberedStep.Container.propTypes = {
  children: PropTypes.node.isRequired,
}

export default NumberedStep
